import { AxiosResponse } from 'axios';
import { Configuration, ConfigurationUpdateRequest } from '../types/config.types';
import api from './api';
import { ApiResponse, Controllers } from '../types/api.types';

export const configurationService = {
    getConfigurations: async (): Promise<ApiResponse<Configuration[]>> => {
        const response: AxiosResponse<ApiResponse<Configuration[]>> = await api.get(`/${Controllers.CONFIG}/all`);
        return response.data;
    },

    updateConfiguration: async (request: ConfigurationUpdateRequest): Promise<ApiResponse<Configuration>> => {
        const response: AxiosResponse<ApiResponse<Configuration>> = await api.post(`/${Controllers.CONFIG}/set`, request);
        return response.data;
    }
}; 